import { FRESHNESS_LABELS } from '../utils/events'

const MapLegend = () => (
    <div className="legend" aria-label="Légende">
        <span className="legend__title">Dernière observation</span>
        <ul>
            {Object.entries(FRESHNESS_LABELS).map(([key, label]) => (
                <li key={key}>
                    <span className={`legend__dot freshness--${key}`} aria-hidden="true" />
                    {label}
                </li>
            ))}
        </ul>
        <span className="legend__note">La taille du point reflète la surface brûlée.</span>
    </div>
)

export default MapLegend
